import { useId } from 'react';
import type React from 'react';

import { cn } from '@change/ds-utils';

type Props = {
	className?: string;
};

/**
 * Local stand-ins for two glyphs `@change/ds-icons` does not have. Replace them if it grows either.
 */

/**
 * Inline rather than a `currentColor` glyph because its fill is a gradient. The gradient id is per
 * instance: with a hard-coded one, a second icon on the page would reference the first's definition.
 */
export const BoltIcon: React.FC<Props> = ({ className }) => {
	const gradientId = useId();

	return (
		<svg viewBox="0 0 19.96 19.96" fill="none" className={cn('h-5 w-5', className)} aria-hidden focusable="false">
			<path
				d="M9.98 0C4.47 0 0 4.47 0 9.98C0 15.49 4.47 19.96 9.98 19.96C15.49 19.96 19.96 15.49 19.96 9.98C19.96 4.47 15.49 0 9.98 0ZM9.98 17.96C5.58 17.96 2 14.38 2 9.98C2 5.58 5.58 2 9.98 2C14.38 2 17.96 5.58 17.96 9.98C17.96 14.38 14.38 17.96 9.98 17.96ZM10.73 2.98L6.23 11.48H9.37V16.98L13.73 8.48H10.73V2.98Z"
				fill={`url(#${gradientId})`}
			/>
			<defs>
				<linearGradient id={gradientId} x1="19.96" y1="19.96" x2="19.96" y2="0" gradientUnits="userSpaceOnUse">
					<stop stopColor="#FE9311" />
					<stop offset="1" stopColor="#FFDB00" />
				</linearGradient>
			</defs>
		</svg>
	);
};

/**
 * Only `className` is read on purpose: `Button` clones its `leadingIcon` with its own icon props,
 * `size` among them, and forwarding that to an `<svg>` renders an invalid width/height.
 */
export const VideocamIcon: React.FC<Props> = ({ className }) => (
	<svg viewBox="0 0 24 24" fill="currentColor" className={cn('h-5 w-5', className)} aria-hidden focusable="false">
		<path d="M4 20q-.825 0-1.412-.588Q2 18.825 2 18V6q0-.825.588-1.413Q3.175 4 4 4h12q.825 0 1.413.587Q18 5.175 18 6v5.5l4-4v9l-4-4V18q0 .825-.587 1.412Q16.825 20 16 20Zm0-2h12V6H4v12Z" />
	</svg>
);
